/**
 * Extrae polígono/parcela catastral de textos libres (Places, nº portal, dirección).
 * Espejo de backend/src/utils/parseDireccionRustica.js
 */
export function extraerPoligonoParcelasTexto(texto) {
  const raw = String(texto || "").trim();
  if (!raw) return null;
  const polM = raw.match(/pol[ií]gono\s*(\d{1,3})/i) || raw.match(/\bpol\.?\s*(\d{1,3})\b/i);
  const parcM = raw.match(/parcelas?\s*([\d\s,yYeE./-]+)/i);
  if (!polM && !parcM) return null;
  const poligono = polM ? parseInt(polM[1], 10) : null;
  let parcelas = [];
  if (parcM) {
    parcelas = String(parcM[1])
      .split(/[^\d]+/)
      .map((s) => s.trim())
      .filter((s) => /^\d{1,5}$/.test(s));
  }
  const limpio = raw
    .replace(/pol[ií]gono\s*\d{1,3}/gi, " ")
    .replace(/\bpol\.?\s*\d{1,3}\b/gi, " ")
    .replace(/parcelas?\s*[\d\s,yYeE./-]+/gi, " ")
    .replace(/[,;]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return {
    poligono: Number.isFinite(poligono) ? poligono : null,
    parcelas,
    resto: limpio,
  };
}

export function esParcelaBasuraTipo(v) {
  const s = String(v || "").trim().toLowerCase();
  if (!s) return true;
  return /^(agraria|urbana|rustica|rústica|solar|terreno|agricola|agrícola)$/i.test(s);
}

export function normalizarDireccionRusticaCaptacion({
  nombre_via,
  calle,
  numero,
  direccion,
  parcela,
  poligono,
} = {}) {
  const via = String(nombre_via || calle || "").trim();
  const num = String(numero || "").trim();
  const dir = String(direccion || "").trim();
  const parsed =
    extraerPoligonoParcelasTexto(num)
    || extraerPoligonoParcelasTexto(dir)
    || extraerPoligonoParcelasTexto([via, num].filter(Boolean).join(", "));

  if (!parsed) return null;

  const patch = {};
  const pol = parsed.poligono != null
    ? parsed.poligono
    : (poligono != null && String(poligono).trim() !== "" ? Number(poligono) : null);
  const parcelas = parsed.parcelas.length
    ? parsed.parcelas
    : (!esParcelaBasuraTipo(parcela) && /^\d/.test(String(parcela || "").trim())
      ? [String(parcela).trim()]
      : []);

  if (pol != null && Number.isFinite(Number(pol))) patch.poligono = String(parseInt(pol, 10));
  if (parcelas.length) patch.parcela = parcelas.join(" y ");

  if (extraerPoligonoParcelasTexto(num)) {
    patch.numero = parsed.resto || "";
  }

  if (via) {
    patch.nombre_via = via;
    patch.calle = via;
  }

  const partesDir = [
    via,
    pol != null ? `Polígono ${parseInt(pol, 10)}` : null,
    parcelas.length
      ? (parcelas.length > 1 ? `parcelas ${parcelas.join(" y ")}` : `parcela ${parcelas[0]}`)
      : null,
  ].filter(Boolean);
  if (partesDir.length) patch.direccion = partesDir.join(", ");

  return patch;
}
